import React from "react";
import { Link } from "react-router-dom";
import markDark from "../assets/logo-mark.png";
import markWhite from "../assets/logo-mark-white.png";

// Official MUVIARTS lockup (self-contained wordmark image) with optional tagline.
export default function Logo({ theme = "light", size = "md", withTagline = false, to = "/" }) {
    const dark = theme === "dark";
    const mark = dark ? markWhite : markDark;
    const dims = { sm: "h-9", md: "h-11 sm:h-12", lg: "h-14 sm:h-16" }[size] || "h-11 sm:h-12";
    const tag = { sm: "text-[8px]", md: "text-[9px]", lg: "text-[10px]" }[size] || "text-[9px]";
    return (
        <Link to={to} className="inline-flex flex-col items-center shrink-0 group" data-testid="brand-logo">
            <img src={mark} alt="MUVIARTS" className={`${dims} w-auto object-contain`} />
            {withTagline && (
                <span className={`mt-1 ${tag} font-semibold uppercase tracking-[0.14em] whitespace-nowrap ${dark ? "text-white/50" : "text-neutral-400"}`}>
                    Build. Release. Grow.
                </span>
            )}
        </Link>
    );
}
